import { Link } from "react-router-dom";

export function Logo({ compact = false }) {
  return (
    <Link to="/" data-testid="brand-logo" className="flex items-center gap-2.5 group">
      <span className="flex h-9 w-9 items-center justify-center rounded-md bg-[#00E676] font-display text-lg font-black tracking-tight text-[#04100a] transition-shadow duration-200 group-hover:shadow-[0_0_18px_rgba(0,230,118,0.5)]">
        MP
      </span>
      {!compact && (
        <span className="font-display text-xl font-extrabold uppercase tracking-wide text-white leading-none">
          Money<span className="text-[#00E676]">Printer</span>
        </span>
      )}
    </Link>
  );
}

export default Logo;
